import React from "react";
import styled from "@emotion/styled";
import { Row, Col, Button } from "antd";
import {
  getLocations,
  getAllDepartmentList,
  getRoleList,
  getLeaveCategoryList,
} from "redux/selectors";
import { connect } from "react-redux";
import moment from "moment";
import { useTranslation } from "react-i18next";

const StyledButton = styled(Button)`
  background: #26a4ff;
  border-radius: 5px;
  color: #ffffff;
  width: 100px;
  font-weight: bold;
`;

const StyledCol = styled(Col)`
  margin: 10px 0;
  .info_heading {
    font-size: 14px;
    font-weight: 400;
    color: #636980;
  }
  .info_datas {
    font-weight: 500;
    color: #1f243b;
  }
  .inreview_title {
    font-size: 16px;
    font-weight: 600;
    width: 26%;
  }
  .inreview_boxes_container {
    display: flex;
    gap: 1rem;
  }
  .roles_location_review {
    width: max-content;
    min-height: 28px;
    font-size: 14px;
    font-weight: 400;
    color: #1f243b;
    padding: 5px 12px;
    border-radius: 4px;
    color: #1f243b;
    background-color: #f4f4f4;
    margin-bottom: 0;
  }
  .roles_location_review_section {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }
  .roles_location_review_wrap {
    width: 100%;
    display: flex;
    gap: 10px;
  }

  @media (min-width: 992px) and (max-width: 1200px) {
    .inreview_col_section {
      width: 30%;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
    }
  }
  @media (min-width: 768px) and (max-width: 991px) {
    .inreview_col_section {
      width: 50%;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
    }
  }
  @media (min-width: 481px) and (max-width: 767px) {
    .inreview_col_section {
      width: 50%;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
    }
  }
  @media (min-width: 320px) and (max-width: 480px) {
    .inreview_boxes_container {
      flex-direction: column;
    }
    .inreview_col_section {
      width: 100%;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
    }
  }
`;

const InReview = ({
  BasicInformation,
  department,
  location,
  role,
  departmentList,
  WorkInformation,
  EducationInformation,
  locationList,
  roleList,
  setStep,
  step,
  handleCreate,
  loading,
  baseLocation,
  baseDepartment,
  leaveAccurals = [],
  leaveCategoryList,
}) => {
  const { t } = useTranslation();

  console.log("leaveCategoryListwww", leaveCategoryList);

  const departmentdata =
    departmentList?.filter((item) =>
      department?.includes(item.department_id)
    ) || null;
  const locationdata =
    locationList?.filter((item) => location?.includes(item.location_id)) ||
    null;
  const roledata =
    roleList?.filter((item) => role?.includes(item.roleId)) || null;

  const baseLocationName = locationList?.filter(
    (item) => item.location_id === baseLocation
  );
  const baseDepartmentnName = departmentList?.filter(
    (item) => item.department_id === baseDepartment
  );

  const basicMappings = {
    full_name: t("Full Name"),
    user_id: t("Email ID"),
    date_of_birth: t("Date of Birth"),
    marital_status: t("Marital Status"),
    start_date: t("Start Date"),
    uan: t("UAN"),
    pan: t("PAN"),
    EmergencyContactName: t("Emergency Contact Name"),
    EmergencyContactNumber: t("Emergency Contact Number"),
    employementtype: t("Employment Type"),
  };

  const EducationMappings = {
    degree: t("Degree"),
    specialization: t("Specialization"),
    institute_Name: t("Institute Name"),
    year_of_completion: t("Year of Completion"),
  };

  const WorkMappings = {
    company_Name: t("Company Name"),
    job_Title: t("Job Title"),
    employee_sponser: t("Employee Sponsor"),
    employee_status: t("Employee Status"),
    professional_since: t("Professional Since"),
    hired_date: t("Hired Date"),
    relevent: t("Relevant"),
  };

  function formatDisplayValue(value) {
    if (typeof value === "string" && value.includes("@")) {
      return value;
    }
    return value ? value.charAt(0).toUpperCase() + value.slice(1) : "-";
  }

  const getLeaveCategoryName = (id) => {
    if (!id) return "-";
    const found = leaveCategoryList?.find(
      (l) => String(l.leave_category_id) === String(id)
    );
    return found?.leave_category_name ?? id ?? "-";
  };

  return (
    <>
      <Row className="p-2 flex-column">
        {/* Basic Information */}
        <StyledCol>
          <div className="inreview_boxes_container">
            <h5 className="inreview_title">{t("Basic Information")}</h5>
            <Row className="w-100">
              {BasicInformation &&
                Object.entries(BasicInformation).map(([key, value]) => {
                  const displayKey =
                    basicMappings[key] ||
                    key.charAt(0).toUpperCase() +
                      key.slice(1).replace(/_/g, " ");
                  const displayValue = formatDisplayValue(value);
                  return (
                    <React.Fragment key={key}>
                      <Col className="inreview_col_section" xl={8}>
                        <b className="info_heading">{displayKey}</b>
                        <p className="info_datas">
                          {key === "start_date" ||
                          key === "end_date" ||
                          key === "year_of_completion" ||
                          key === "date_of_birth"
                            ? moment(value).format("D MMMM, YYYY")
                            : displayValue}
                        </p>
                      </Col>
                    </React.Fragment>
                  );
                })}
            </Row>
          </div>
        </StyledCol>

        {/* Role */}
        {roledata.length > 0 && (
          <StyledCol>
            <div className="inreview_boxes_container">
              <h5 className="inreview_title">{t("Role")}</h5>
              <Row className="roles_location_review_wrap">
                {roledata?.map((item, key) => (
                  <React.Fragment key={key}>
                    <Col className="roles_location_review_section">
                      <p className="roles_location_review">{item?.roleName}</p>
                    </Col>
                  </React.Fragment>
                ))}
              </Row>
            </div>
          </StyledCol>
        )}

        {/* Base Location */}
        {baseLocation && baseLocationName?.length !== 0 && (
          <StyledCol>
            <div className="inreview_boxes_container">
              <h5 className="inreview_title">{t("Base Location")}</h5>
              <Row className="roles_location_review_wrap">
                <Col className="roles_location_review_section">
                  <p className="roles_location_review">
                    {baseLocationName[0]?.location_name}
                  </p>
                </Col>
              </Row>
            </div>
          </StyledCol>
        )}

        {/* Base Department */}
        {baseDepartment && baseDepartmentnName?.length !== 0 && (
          <StyledCol>
            <div className="inreview_boxes_container">
              <h5 className="inreview_title">{t("Base Department")}</h5>
              <Row className="roles_location_review_wrap">
                <Col className="roles_location_review_section">
                  <p className="roles_location_review">
                    {baseDepartmentnName[0]?.department_name}
                  </p>
                </Col>
              </Row>
            </div>
          </StyledCol>
        )}

        {/* Work Information */}
        <StyledCol>
          <div className="inreview_boxes_container">
            <h5 className="inreview_title">{t("Work Information")}</h5>
            <Row className="w-100">
              {WorkInformation &&
                Object.entries(WorkInformation).map(([key, value]) => {
                  const displayKey =
                    WorkMappings[key] ||
                    key.charAt(0).toUpperCase() +
                      key.slice(1).replace(/_/g, " ");
                  const displayValue = formatDisplayValue(value);
                  return (
                    <React.Fragment key={key}>
                      <Col className="inreview_col_section" xl={8}>
                        <b className="info_heading">{displayKey}</b>
                        <p className="info_datas">
                          {key === "start_date" || key === "hired_date"
                            ? moment(value).format("D MMMM, YYYY")
                            : value === false
                            ? "false"
                            : value === true
                            ? "true"
                            : displayValue}
                        </p>
                      </Col>
                    </React.Fragment>
                  );
                })}
            </Row>
          </div>
        </StyledCol>

        {/* Location */}
        {locationdata?.length > 0 && (
          <StyledCol>
            <div className="inreview_boxes_container">
              <h5 className="inreview_title">{t("Location")}</h5>
              <Row className="roles_location_review_wrap">
                {locationdata?.map((item, key) => (
                  <React.Fragment key={key}>
                    <Col className="roles_location_review_section">
                      <p className="roles_location_review">
                        {item?.location_name}
                      </p>
                    </Col>
                  </React.Fragment>
                ))}
              </Row>
            </div>
          </StyledCol>
        )}

        {/* Department */}
        {departmentdata?.length > 0 && (
          <StyledCol>
            <div className="inreview_boxes_container">
              <h5 className="inreview_title">{t("Department")}</h5>
              <Row className="roles_location_review_wrap">
                {departmentdata?.map((item, key) => (
                  <React.Fragment key={key}>
                    <Col className="roles_location_review_section">
                      <p className="roles_location_review">
                        {item?.department_name}
                      </p>
                    </Col>
                  </React.Fragment>
                ))}
              </Row>
            </div>
          </StyledCol>
        )}

        {/* Leave Management */}
        {leaveAccurals && leaveAccurals.length > 0 && (
          <StyledCol>
            <div className="inreview_boxes_container">
              <h5 className="inreview_title">{t("Leave Management")}</h5>
              <Row className="w-100">
                {leaveAccurals.map((item, idx) => {
                  const isLast = idx === leaveAccurals.length - 1;
                  return (
                    <React.Fragment key={idx}>
                      <Col xs={24} style={{ marginBottom: 12 }}>
                        {/* Row 1: Leave Type | Opening Leaves */}
                        <Row gutter={16}>
                          <Col xs={12} className="inreview_col_section">
                            <b className="info_heading">{t("Leave Type")}</b>
                            <p className="info_datas">
                              {getLeaveCategoryName(item.leave_category_id)}
                            </p>
                          </Col>
                          <Col xs={12} className="inreview_col_section">
                            <b className="info_heading">
                              {t("Opening Leaves")}
                            </b>
                            <p className="info_datas">
                              {item.openingLeaves ?? "-"}
                            </p>
                          </Col>
                        </Row>

                        {/* Row 2: Accrual | Accrual Frequency */}
                        <Row gutter={16} style={{ marginTop: 8 }}>
                          <Col xs={12} className="inreview_col_section">
                            <b className="info_heading">{t("Accrual")}</b>
                            <p className="info_datas">{item.accrual ?? "-"}</p>
                          </Col>
                          <Col xs={12} className="inreview_col_section">
                            <b className="info_heading">
                              {t("Accrual Frequency")}
                            </b>
                            <p className="info_datas">
                              {item.accrualtype ?? "-"}
                            </p>
                          </Col>
                        </Row>

                        {/* Row 3: Accrual Days */}
                        <Row gutter={16} style={{ marginTop: 8 }}>
                          <Col xs={12} className="inreview_col_section">
                            <b className="info_heading">{t("Accrual Days")}</b>
                            <p className="info_datas">
                              {item.number_of_leaves ?? "-"}
                            </p>
                          </Col>
                          <Col xs={12} className="inreview_col_section">
                            <b
                              className="info_heading"
                              style={{ visibility: "hidden" }}
                            >
                              .
                            </b>
                            <p
                              className="info_datas"
                              style={{ visibility: "hidden" }}
                            >
                              .
                            </p>
                          </Col>
                        </Row>
                      </Col>

                      {!isLast && (
                        <Col xs={24}>
                          <hr
                            style={{
                              border: 0,
                              borderTop: "2px solid #e8e8e8",
                              margin: "8px 0 16px",
                            }}
                          />
                        </Col>
                      )}
                    </React.Fragment>
                  );
                })}
              </Row>
            </div>
          </StyledCol>
        )}
      </Row>

      <div className="w-100 text-end">
        <StyledButton
          type="primary"
          className="mt-3 mx-2"
          onClick={() => {
            setStep(step - 1);
          }}
        >
          {t("Back")}
        </StyledButton>
        <StyledButton
          type="primary"
          loading={loading}
          className="mt-3"
          onClick={handleCreate}
        >
          {t("Create")}
        </StyledButton>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  locationList: getLocations(state),
  departmentList: getAllDepartmentList(state),
  roleList: getRoleList(state),
  leaveCategoryList: getLeaveCategoryList(state),
});

export default connect(mapStateToProps)(InReview);
